import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTag: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="tag, sale"><path fillRule="evenodd" clipRule="evenodd" d="M2 5.75C2 3.67893 3.67893 2 5.75 2H10.7411C11.7357 2 12.6895 2.39509 13.3928 3.09835L20.909 10.6146C22.3735 12.079 22.3735 14.4534 20.909 15.9179L15.9179 20.909C14.4534 22.3735 12.079 22.3735 10.6146 20.909L3.09835 13.3928C2.39509 12.6895 2 11.7357 2 10.7411V5.75ZM7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9Z" fill="currentColor"/></CentralIconBase>;
};

export default IconTag;
